import React from "react";
import { Box, CircularProgress } from "@mui/material";
import { useDispatchWrapper } from "../../../../../../hooks";
import { showMessage } from "../../../../../../redux/messages/messagesActions";
import {
  fetchCommAutoChecklistSavedStatusAsync,
  saveCommAutoChecklistResponseAsync,
} from "../../../../../../redux/commAutoPolicy/commAutoMarketingHistory/commAutoMarketingHistoryActions";
import { ITemplateField } from "../../../../../../redux/CustomFormFields/CustomFormFields.types";
import { DynamicFormRenderer } from "../../../../../CustomFormFields/DynamicFormRenderer";

interface ICommAutoChecklistTabProps {
  customerId: number | string;
  customerPolicyId: number | string;
  onSaveSuccess: () => void;
}

export const CommAutoChecklistTab: React.FC<ICommAutoChecklistTabProps> = (
  props
) => {
  const { customerId, customerPolicyId, onSaveSuccess } = props;

  const dispatch = useDispatchWrapper();

  // Local fields state — mirrors the step 9 pattern.
  // null  → no saved data yet; DynamicFormRenderer will self-fetch the template.
  // array → saved data from get-policy-binder-checklist; shown directly.
  const [fields, setFields] = React.useState<ITemplateField[] | null>(null);
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    if (!customerPolicyId) {
      setLoading(false);
      return;
    }
    setLoading(true);
    dispatch(
      fetchCommAutoChecklistSavedStatusAsync(customerPolicyId, (savedFields) => {
        // savedFields is the checklist array when data exists, null otherwise.
        setFields(savedFields);
        setLoading(false);
      })
    );
  }, [customerPolicyId]);

  const handleSubmit = (updatedFields: ITemplateField[]) => {
    dispatch(
      saveCommAutoChecklistResponseAsync(
        customerId,
        customerPolicyId,
        updatedFields,
        () => {
          // After save, re-fetch from get-policy-binder-checklist so the form
          // shows the persisted values (not the empty questionnaire template).
          dispatch(
            fetchCommAutoChecklistSavedStatusAsync(
              customerPolicyId,
              (savedFields) => {
                setFields(savedFields);
              }
            )
          );
          onSaveSuccess();
          dispatch(
            showMessage({
              type: "success",
              message: "Checklist saved successfully!",
              displayAs: "snackbar",
            })
          );
        },
        (message: string) => {
          dispatch(
            showMessage({
              type: "error",
              message,
              displayAs: "snackbar",
            })
          );
        }
      )
    );
  };

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" py={4}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <DynamicFormRenderer
      templateCode="IZIQNY"
      fields={fields}
      onSubmit={handleSubmit}
    />
  );
};
